// UI string dictionaries. Keys are shared across EN/IT.
export const translations = {
  en: {
    "nav.home": "Home",
    "nav.services": "Services",
    "nav.journeys": "Tuscany Journeys",
    "nav.reserve": "Reserve",
    "lang.switch": "IT",

    "hero.overline": "Tuscany",
    "hero.cta": "Reserve your journey",

    "philosophy.overline": "The philosophy",
    "philosophy.headline": "A small company by choice — for those who value the journey as much as the destination.",

    "servicesOverview.overline": "What we offer",
    "servicesOverview.title": "Services",
    "servicesOverview.all": "All services",

    "fixed.overline": "Cruise & yacht guests",
    "fixed.headline": "Step off the ship. Into the hush of Tuscany. Back before you're missed.",
    "fixed.sub": "Shore excursions timed to your ship at Livorno & La Spezia. Private transfers for yachts at Viareggio & Carrara.",

    "reviews.overline": "Google Reviews",
    "reviews.viewOnGoogle": "View on Google",
    "reviews.providedByGoogle": "Reviews provided by Google · see all on Google Maps",
    "guides.reviewsTitle": "Trusted by travellers from around the world",
    "home.guidesOverline": "Guides & Destinations",
    "home.guidesTitle": "Explore Tuscany, your way",
    "home.guidesSubtitle": "Curated private itineraries — from cruise-port days to bespoke wine tours across Tuscany and the coast.",

    "contact.overline": "Reservations",
    "contact.title": "Begin the conversation",
    "contact.text": "Share a few details and we'll craft a proposal tailored to you. For an immediate reply, reach us on WhatsApp.",

    "services.overline": "What we offer",
    "services.title": "Services crafted around you",
    "services.intro": "Every service is delivered with the same understated precision — a spotless Mercedes V-Class, a discreet chauffeur, and time returned to you.",
    "services.enquire": "Enquire now",
    "services.viewItineraries": "View Tuscany itineraries",
    "services.ctaTitle": "Cruise or yacht guest?",
    "services.ctaText": "Explore our ready-made Tuscany itineraries, timed perfectly to your arrival.",
    "services.ctaButton": "Discover the itineraries",

    "journeys.overline": "Shore excursions & day itineraries",
    "journeys.title": "Our Tuscany journeys",
    "journeys.intro": "Curated full and half-day journeys, timed precisely to your ship or yacht arrival at Livorno, La Spezia, Viareggio and Carrara. Choose an itinerary and we'll take care of the driving, timing and logistics.",
    "journeys.book": "Book this itinerary",
    "journeys.ctaHeadline": "Something else in mind? We design private itineraries entirely from scratch.",

    "footer.contact": "Contact",
    "nav.guides": "Guides",
    "nav.guidesTransfers": "Transfers",
    "nav.guidesTours": "Tours & Destinations",
    "footer.explore": "Explore",
    "footer.cruiseGuide": "Cruise Port Transfers",
    "footer.florencePisaGuide": "Florence & Pisa from Livorno",
    "footer.laSpeziaGuide": "La Spezia Shore Excursions",
    "footer.privateDriverGuide": "Private Driver Tuscany",
    "footer.wineGuide": "Tuscany Wine Tours",
    "footer.airportGuide": "Airport Transfers",
    "footer.yachtGuide": "Yacht Transfers",
    "footer.florenceGuide": "Florence Tour",
    "footer.pisaGuide": "Pisa & Leaning Tower",
    "footer.cinqueTerreGuide": "Cinque Terre Tour",
    "footer.valdorciaGuide": "Val d'Orcia Tour",
    "footer.location": "Pisa, Tuscany",
    "footer.rights": "All rights reserved.",
    "disclaimer.services": "Please note: We provide professional chauffeur-driven transportation services. Our suggested itineraries focus on travel and destination experiences. Entrance fees to attractions, meals, and guided walking tours are not included and remain the responsibility of the client.",

    "cookie.overline": "Privacy & Cookies",
    "cookie.body": "We use technical cookies to make this site work and, with your consent, optional cookies for analytics. To continue browsing, please make a choice below. Read our",
    "cookie.policyLink": "Cookie Policy",
    "cookie.acceptAll": "Accept all",
    "cookie.technicalOnly": "Technical only",
    "cookie.customize": "Customize",
    "cookie.save": "Save choices",
    "cookie.technicalLabel": "Technical (required)",
    "cookie.analyticsLabel": "Analytics (optional)",

    // Forms — shared
    "form.fullName": "Full name",
    "form.fullNamePh": "Your name",
    "form.namePh": "Name and surname",
    "form.phone": "Phone",
    "form.email": "Email",
    "form.emailPh": "you@email.com",
    "form.confirmEmail": "Confirm email",
    "form.confirmEmailPh": "Re-enter your email",
    "form.passengers": "Passengers",
    "form.passengersPh": "Number of passengers",
    "form.passengersPhShort": "How many?",
    "form.serviceType": "Service type",
    "form.serviceTypePh": "Choose a service",
    "form.date": "Date of service",
    "form.dateShort": "Date",
    "form.pickupTime": "Pick-up time",
    "form.pickupFrom": "Pick-up from",
    "form.select": "Select",
    "form.optAddress": "An address",
    "form.optAirport": "An airport",
    "form.optPort": "A port",
    "form.optOther": "Other",
    "form.flightNumber": "Flight number",
    "form.flightNumberPh": "e.g. AZ1234",
    "form.flightOrigin": "Flight origin",
    "form.flightOriginPh": "Departure city",
    "form.dropoffAddress": "Drop-off address",
    "form.dropoffAddressPh": "Street and number (or fill the hotel)",
    "form.dropoffAddressPhPlain": "Street and number",
    "form.dropoffHotel": "Drop-off hotel / apartment name",
    "form.hotel": "Hotel / apartment name",
    "form.hotelPh": "Name (or fill the address)",
    "form.cityDropoff": "City of drop-off",
    "form.cityDropoffPh": "e.g. Florence",
    "form.cityPickup": "City of pick-up",
    "form.cityPickupPh": "e.g. Lucca",
    "form.pickupAddress": "Pick-up address",
    "form.pickupAddressPh": "Street and number (or fill the hotel)",
    "form.portName": "Port name",
    "form.portNamePh": "Select the port",
    "form.luggage": "Number of luggage",
    "form.luggagePh": "How many bags?",
    "form.needReturn": "I need a return trip",
    "form.returnDate": "Return date",
    "form.returnTime": "Return time",
    "form.returnMode": "Return pick-up from",
    "form.returnFlight": "Return flight number",
    "form.returnFlightOrigin": "Return flight origin",
    "form.returnPort": "Return port name",
    "form.returnAddress": "Return pick-up address",
    "form.returnAddressPh": "Address",
    "form.describeDay": "Describe your ideal day",
    "form.describeDayPh": "Places you dream of, pace, interests…",
    "form.piPickup": "Pick-up address",
    "form.piPickupPh": "Where should we collect you?",
    "form.shipName": "Ship name",
    "form.shipNamePh": "Name of your ship",
    "form.arrivalPort": "Arrival port",
    "form.arrivalPortPh": "Port of arrival",
    "form.destination": "Destination address",
    "form.destinationPh": "Where to?",
    "form.hours": "Hours of disposition",
    "form.hoursPh": "e.g. 4 hours",
    "form.additional": "Additional requests",
    "form.additionalPh": "Anything else?",
    "form.notes": "Notes & additional requests (optional)",
    "form.notesPh": "Tell us anything that helps us tailor your service",
    "form.consentPrivacy1": "I have read and accept the",
    "form.privacyPolicy": "Privacy Policy",
    "form.cancellationPolicy": "Cancellation Policy",
    "form.termsService": "Terms & What's Included",
    "form.termsNote": "See also our",
    "form.send": "Send request",
    "form.sending": "Sending…",
    "form.pickupPoint": "Pick-up point",
    "form.pickupPointPh": "Where do we collect you?",
    "form.optCruise": "Cruise ship",
    "form.optHotel": "Hotel / apartment",
    "form.dockingPort": "Docking port",
    "form.portPh": "Port",
    "form.address": "Address",
    "form.addressPh": "Street, number",
    "form.city": "City",
    "form.cityPh": "City",
    "form.requestBooking": "Request booking",
    "form.bookOverline": "Book this itinerary",
    "form.toastRequired": "Please complete all the required fields highlighted in red.",
    "form.toastEmailMismatch": "The email addresses do not match. Please check for typos.",
    "form.toastError": "Something went wrong. Please try again or reach us on WhatsApp.",
    "form.successTitle": "Thank you",
    "form.successText": "You'll be contacted as soon as possible by our booking manager.",
    "form.sendAnother": "Send another request",
    "form.close": "Close",
    "form.paxOnRequest": "On request (8+)",

    "legal.overline": "Legal",
    "legal.updated": "Last updated:",

    "seo.home.title": "Your Black Limo · Luxury Chauffeur in Tuscany — Mercedes V-Class NCC",
    "seo.home.desc": "Private NCC chauffeur service in Tuscany. Bespoke itineraries, cruise transfers (Livorno, La Spezia) and yacht transfers (Viareggio, Carrara) in a Mercedes V-Class. Understated luxury from Lucca & Pisa.",
    "seo.services.title": "Services · Your Black Limo — Transfers, Private Itineraries & Shore Excursions",
    "seo.services.desc": "Point-to-point transfers, private itineraries, cruise shore excursions, hours disposition and shopping & leisure across Tuscany, in a chauffeured Mercedes V-Class.",
    "seo.journeys.title": "Tuscany Itineraries for Cruise & Yacht Guests · Your Black Limo",
    "seo.journeys.desc": "Private Tuscany itineraries from Livorno, La Spezia, Viareggio & Carrara: Pisa & Florence, Siena & San Gimignano, Cinque Terre, Carrara marble caves and more. Chauffeured Mercedes V-Class.",
    "seo.privacy.title": "Privacy Policy · Your Black Limo",
    "seo.privacy.desc": "Privacy policy of Your Black Limo di Lombardi Antonio, in accordance with the EU GDPR (Regulation 2016/679) and Italian data-protection law.",
    "seo.cookie.title": "Cookie Policy · Your Black Limo",
    "seo.cookie.desc": "Cookie policy of Your Black Limo, in accordance with EU Regulation 2016/679 and Italian data-protection guidelines on the use of cookies and tracking tools.",
    "seo.cancellation.title": "Cancellation Policy · Your Black Limo",
    "seo.cancellation.desc": "Cancellation policy of Your Black Limo: cancellation fees, flight and train delays, and complimentary waiting times for chauffeur services in Tuscany.",
    "seo.terms.title": "Terms of Service / What's Included · Your Black Limo",
    "seo.terms.desc": "Your Black Limo provides private chauffeur-driven transportation only. See what's included, what's not, and how meals, tastings, tickets and guided tours are booked directly by the client.",
  },

  it: {
    "nav.home": "Home",
    "nav.services": "Servizi",
    "nav.journeys": "Itinerari in Toscana",
    "nav.reserve": "Prenota",
    "lang.switch": "EN",

    "hero.overline": "Toscana",
    "hero.cta": "Prenota il tuo viaggio",

    "philosophy.overline": "La filosofia",
    "philosophy.headline": "Una piccola azienda per scelta — per chi dà valore al viaggio tanto quanto alla destinazione.",

    "servicesOverview.overline": "Cosa offriamo",
    "servicesOverview.title": "Servizi",
    "servicesOverview.all": "Tutti i servizi",

    "fixed.overline": "Ospiti di crociere e yacht",
    "fixed.headline": "Scendete dalla nave. Nel silenzio della Toscana. E tornate prima che vi cerchino.",
    "fixed.sub": "Escursioni a terra calibrate sugli orari della vostra nave a Livorno e La Spezia. Transfer privati per yacht a Viareggio e Carrara.",

    "reviews.overline": "Recensioni Google",
    "reviews.viewOnGoogle": "Vedi su Google",
    "reviews.providedByGoogle": "Recensioni fornite da Google · vedi tutte su Google Maps",
    "guides.reviewsTitle": "La fiducia di viaggiatori da tutto il mondo",
    "home.guidesOverline": "Guide e Destinazioni",
    "home.guidesTitle": "Esplora la Toscana, a modo tuo",
    "home.guidesSubtitle": "Itinerari privati su misura — dalle giornate in porto ai tour del vino su misura in Toscana e sulla costa.",

    "contact.overline": "Prenotazioni",
    "contact.title": "Iniziamo a parlarne",
    "contact.text": "Condividi qualche dettaglio e prepareremo una proposta su misura per te. Per una risposta immediata, scrivici su WhatsApp.",

    "services.overline": "Cosa offriamo",
    "services.title": "Servizi pensati intorno a te",
    "services.intro": "Ogni servizio è offerto con la stessa precisione discreta — una Mercedes Classe V impeccabile, un autista riservato e il tempo restituito a te.",
    "services.enquire": "Richiedi ora",
    "services.viewItineraries": "Vedi gli itinerari in Toscana",
    "services.ctaTitle": "Ospite di una crociera o di uno yacht?",
    "services.ctaText": "Scopri i nostri itinerari in Toscana pronti all'uso, calibrati perfettamente sul tuo arrivo.",
    "services.ctaButton": "Scopri gli itinerari",

    "journeys.overline": "Escursioni a terra e itinerari giornalieri",
    "journeys.title": "I nostri itinerari in Toscana",
    "journeys.intro": "Itinerari curati di intera o mezza giornata, calibrati con precisione sull'arrivo della tua nave o del tuo yacht a Livorno, La Spezia, Viareggio e Carrara. Scegli un itinerario e pensiamo noi alla guida, ai tempi e alla logistica.",
    "journeys.book": "Prenota questo itinerario",
    "journeys.ctaHeadline": "Hai in mente qualcos'altro? Progettiamo itinerari privati interamente su misura.",

    "footer.contact": "Contatti",
    "nav.guides": "Guide",
    "nav.guidesTransfers": "Transfer",
    "nav.guidesTours": "Tour e Destinazioni",
    "footer.explore": "Esplora",
    "footer.cruiseGuide": "Transfer Crociere",
    "footer.florencePisaGuide": "Firenze e Pisa da Livorno",
    "footer.laSpeziaGuide": "Escursioni da La Spezia",
    "footer.privateDriverGuide": "Autista Privato Toscana",
    "footer.wineGuide": "Tour del Vino in Toscana",
    "footer.airportGuide": "Transfer Aeroportuali",
    "footer.yachtGuide": "Transfer Yacht",
    "footer.florenceGuide": "Tour di Firenze",
    "footer.pisaGuide": "Pisa e Torre Pendente",
    "footer.cinqueTerreGuide": "Tour Cinque Terre",
    "footer.valdorciaGuide": "Tour Val d'Orcia",
    "footer.location": "Pisa, Toscana",
    "footer.rights": "Tutti i diritti riservati.",
    "disclaimer.services": "Nota bene: forniamo servizi professionali di trasporto con autista privato. Gli itinerari suggeriti sono incentrati sul viaggio e sull'esperienza delle destinazioni. Biglietti d'ingresso alle attrazioni, pasti e visite guidate a piedi non sono inclusi e restano a carico del cliente.",

    "cookie.overline": "Privacy e Cookie",
    "cookie.body": "Utilizziamo cookie tecnici per il funzionamento del sito e, con il tuo consenso, cookie opzionali per le statistiche. Per continuare la navigazione, effettua una scelta qui sotto. Leggi la nostra",
    "cookie.policyLink": "Cookie Policy",
    "cookie.acceptAll": "Accetta tutti",
    "cookie.technicalOnly": "Solo tecnici",
    "cookie.customize": "Personalizza",
    "cookie.save": "Salva le scelte",
    "cookie.technicalLabel": "Tecnici (obbligatori)",
    "cookie.analyticsLabel": "Statistiche (opzionali)",

    "form.fullName": "Nome completo",
    "form.fullNamePh": "Il tuo nome",
    "form.namePh": "Nome e cognome",
    "form.phone": "Telefono",
    "form.email": "Email",
    "form.emailPh": "tu@email.com",
    "form.confirmEmail": "Conferma email",
    "form.confirmEmailPh": "Reinserisci la tua email",
    "form.passengers": "Passeggeri",
    "form.passengersPh": "Numero di passeggeri",
    "form.passengersPhShort": "Quanti?",
    "form.serviceType": "Tipo di servizio",
    "form.serviceTypePh": "Scegli un servizio",
    "form.date": "Data del servizio",
    "form.dateShort": "Data",
    "form.pickupTime": "Orario di ritiro",
    "form.pickupFrom": "Ritiro da",
    "form.select": "Seleziona",
    "form.optAddress": "Un indirizzo",
    "form.optAirport": "Un aeroporto",
    "form.optPort": "Un porto",
    "form.optOther": "Altro",
    "form.flightNumber": "Numero del volo",
    "form.flightNumberPh": "es. AZ1234",
    "form.flightOrigin": "Origine del volo",
    "form.flightOriginPh": "Città di partenza",
    "form.dropoffAddress": "Indirizzo di arrivo",
    "form.dropoffAddressPh": "Via e numero (oppure compila l'hotel)",
    "form.dropoffAddressPhPlain": "Via e numero",
    "form.dropoffHotel": "Hotel / appartamento di arrivo",
    "form.hotel": "Nome hotel / appartamento",
    "form.hotelPh": "Nome (oppure compila l'indirizzo)",
    "form.cityDropoff": "Città di arrivo",
    "form.cityDropoffPh": "es. Firenze",
    "form.cityPickup": "Città di partenza",
    "form.cityPickupPh": "es. Lucca",
    "form.pickupAddress": "Indirizzo di partenza",
    "form.pickupAddressPh": "Via e numero (oppure compila l'hotel)",
    "form.portName": "Nome del porto",
    "form.portNamePh": "Seleziona il porto",
    "form.luggage": "Numero di bagagli",
    "form.luggagePh": "Quanti bagagli?",
    "form.needReturn": "Mi serve anche il ritorno",
    "form.returnDate": "Data di ritorno",
    "form.returnTime": "Orario di ritorno",
    "form.returnMode": "Ritiro del ritorno da",
    "form.returnFlight": "Numero del volo di ritorno",
    "form.returnFlightOrigin": "Origine del volo di ritorno",
    "form.returnPort": "Nome del porto di ritorno",
    "form.returnAddress": "Indirizzo di ritiro del ritorno",
    "form.returnAddressPh": "Indirizzo",
    "form.describeDay": "Descrivi la tua giornata ideale",
    "form.describeDayPh": "Luoghi che sogni, ritmo, interessi…",
    "form.piPickup": "Indirizzo di ritiro",
    "form.piPickupPh": "Dove dobbiamo venirti a prendere?",
    "form.shipName": "Nome della nave",
    "form.shipNamePh": "Nome della tua nave",
    "form.arrivalPort": "Porto di arrivo",
    "form.arrivalPortPh": "Porto di arrivo",
    "form.destination": "Indirizzo di destinazione",
    "form.destinationPh": "Dove desideri andare?",
    "form.hours": "Ore a disposizione",
    "form.hoursPh": "es. 4 ore",
    "form.additional": "Richieste aggiuntive",
    "form.additionalPh": "Qualcos'altro?",
    "form.notes": "Note e richieste aggiuntive (facoltativo)",
    "form.notesPh": "Dicci qualsiasi cosa possa aiutarci a personalizzare il servizio",
    "form.consentPrivacy1": "Ho letto e accetto la",
    "form.privacyPolicy": "Privacy Policy",
    "form.cancellationPolicy": "Cancellation Policy",
    "form.termsService": "Termini / Cosa è incluso",
    "form.termsNote": "Consulta anche i nostri",
    "form.send": "Invia richiesta",
    "form.sending": "Invio in corso…",
    "form.pickupPoint": "Punto di ritiro",
    "form.pickupPointPh": "Dove ti veniamo a prendere?",
    "form.optCruise": "Nave da crociera",
    "form.optHotel": "Hotel / appartamento",
    "form.dockingPort": "Porto di attracco",
    "form.portPh": "Porto",
    "form.address": "Indirizzo",
    "form.addressPh": "Via, numero",
    "form.city": "Città",
    "form.cityPh": "Città",
    "form.requestBooking": "Richiedi la prenotazione",
    "form.bookOverline": "Prenota questo itinerario",
    "form.toastRequired": "Completa tutti i campi obbligatori evidenziati in rosso.",
    "form.toastEmailMismatch": "Gli indirizzi email non coincidono. Controlla di non aver fatto errori.",
    "form.toastError": "Qualcosa è andato storto. Riprova o scrivici su WhatsApp.",
    "form.successTitle": "Grazie",
    "form.successText": "Sarai contattato al più presto dal nostro booking manager.",
    "form.sendAnother": "Invia un'altra richiesta",
    "form.close": "Chiudi",
    "form.paxOnRequest": "Su richiesta (8+)",

    "legal.overline": "Note legali",
    "legal.updated": "Ultimo aggiornamento:",

    "seo.home.title": "Your Black Limo · Chauffeur di Lusso in Toscana — NCC Mercedes Classe V",
    "seo.home.desc": "Servizio NCC di chauffeur privato in Toscana. Itinerari su misura, transfer per crociere (Livorno, La Spezia) e yacht (Viareggio, Carrara) con Mercedes Classe V. Lusso non ostentato da Lucca e Pisa.",
    "seo.services.title": "Servizi · Your Black Limo — Transfer, Itinerari Privati ed Escursioni a Terra",
    "seo.services.desc": "Transfer da punto a punto, itinerari privati, escursioni a terra per crociere, auto a disposizione e shopping in Toscana, con Mercedes Classe V con autista.",
    "seo.journeys.title": "Itinerari in Toscana per Ospiti di Crociere e Yacht · Your Black Limo",
    "seo.journeys.desc": "Itinerari privati in Toscana da Livorno, La Spezia, Viareggio e Carrara: Pisa e Firenze, Siena e San Gimignano, Cinque Terre, cave di marmo di Carrara e altro. Mercedes Classe V con autista.",
    "seo.privacy.title": "Privacy Policy · Your Black Limo",
    "seo.privacy.desc": "Informativa privacy di Your Black Limo di Lombardi Antonio, conforme al GDPR UE (Reg. 2016/679) e alla normativa italiana sulla protezione dei dati.",
    "seo.cookie.title": "Cookie Policy · Your Black Limo",
    "seo.cookie.desc": "Cookie policy di Your Black Limo, in conformità al Regolamento UE 2016/679 e alle linee guida italiane sull'uso di cookie e strumenti di tracciamento.",
    "seo.cancellation.title": "Politica di Cancellazione · Your Black Limo",
    "seo.cancellation.desc": "Politica di cancellazione di Your Black Limo: penali, ritardi di voli e treni e tempi di attesa gratuiti per i servizi con autista in Toscana.",
    "seo.terms.title": "Termini di Servizio / Cosa è Incluso · Your Black Limo",
    "seo.terms.desc": "Your Black Limo fornisce esclusivamente trasporto privato con autista. Scopri cosa è incluso, cosa non lo è e come pasti, degustazioni, biglietti e visite guidate siano prenotati direttamente dal cliente.",
  },
};
